var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integration-and-Tutorials",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations---III-1280-PX",
    transform: "translate(-768.000000, -208.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "THUMBNAIL",
    transform: "translate(665.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Refresh",
    transform: "translate(103.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Blue",
    fill: "#3E98FF",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1487895,5.02456255 C12.2685177,5.07369405 12.3461708,5.19060957 12.3461872,5.31994367 L12.3461872,7.84902322 C12.3461872,8.02525182 12.20302,8.16871514 12.0262486,8.16871514 L9.49741577,8.16871514 C9.36806522,8.16871514 9.25146222,8.09078242 9.20173858,7.97103776 C9.15262353,7.85185235 9.17971411,7.7140473 9.27123325,7.62256107 L10.0139133,6.88045671 C9.22519406,6.42580533 8.19869614,6.53311496 7.52519823,7.20687604 L7.18687023,7.54520404 C7.05697688,7.67511384 6.88671906,7.74005229 6.71613227,7.74005229 C6.54612117,7.74005229 6.37556728,7.67509739 6.24567393,7.54520404 C5.98585434,7.28538446 5.98585434,6.86349837 6.24567393,6.60371167 L6.58396904,6.26540012 C7.77847134,5.07086492 9.64734332,4.95847271 10.9734825,5.92031181 L11.8003128,5.09346508 C11.8918319,5.00196239 12.0293244,4.97485536 12.1487895,5.02456255 Z M11.1593006,10.4549663 C11.4190872,10.1951632 11.8406937,10.1951632 12.1007929,10.4549663 C12.3605796,10.7147695 12.3605796,11.1360799 12.1007929,11.3964587 L11.7627939,11.7341946 C11.1214527,12.3757825 10.2691931,12.7287661 9.36243986,12.7287661 C8.6366688,12.7287661 7.94764357,12.4988991 7.37184941,12.0804178 L6.54612117,12.9061132 C6.45461849,12.9975994 6.31682989,13.0252821 6.1973813,12.9756078 C6.07793272,12.9259006 6,12.8095279 6,12.6802267 L6,10.1511143 C6,9.9743593 6.14316724,9.83143879 6.31993865,9.83143879 L8.84875501,9.83143879 C8.97810556,9.83143879 9.09472502,9.90935506 9.14443221,10.0285569 C9.19384333,10.1482687 9.16671985,10.2855145 9.07493754,10.3770172 L8.33197786,11.1202565 C8.64206389,11.2998734 8.99447176,11.3975772 9.36243986,11.3975772 C9.91339687,11.3975772 10.4318353,11.1829415 10.8212686,10.7932614 L11.1593006,10.4549663 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.93cc1db63288e24d8678d4a50eef4b4a.svg";
export { ForwardRef as ReactComponent };